import {Model} from './model';

export class InvoiceState implements Model {
  invoiceStateId: number;
  type: string;
  successStateId?: number;
  failureStateId?: number;
  description: string;

  static copy(oldObj: InvoiceState): InvoiceState {
    const newObj = new InvoiceState();
    newObj.invoiceStateId = oldObj.invoiceStateId;
    newObj.type = oldObj.type;
    newObj.successStateId = oldObj.successStateId;
    newObj.failureStateId = oldObj.failureStateId;
    newObj.description = oldObj.description;
    return newObj;
  }

  getPrimaryKey(): number {
    return this.invoiceStateId;
  }

  isNew(): boolean {
    return isNaN(this.invoiceStateId);
  }

  clone(): InvoiceState {
    return InvoiceState.copy(this);
  }
}

export enum InvoiceStatusType {
  WAITING = 'waiting',
  REJECTED = 'rejected',
  CLOSED = 'closed',
  ERROR = 'error'
}

export enum InvoiceStateId {
  None = 0,
  PreCheck,
  WaitingForPrepaymentRegister,
  NoPrepaymentRegister,
  WaitingForRepresentativeMandate,
  NoMandate,
  WaitingInvoiceInformation,
  WaitingForCreditDecision,
  WaitingForDisputeCheck,
  Disputed,
  CreditRatingNotOk,
  Rejected,
  WaitingForOfferToBeSent,
  WaitingForOfferApproval,
  OfferRejected,
  WaitingForFinancing,
  Closed,
  WaitingForInvoiceToEndCustomer,
  MonitoringEndCustomerPayments,
  WaitingFinalPayment,
  WaitingForReport,
  Completed,
  WaitingForDisputeMailToBeSent
}
